// 限制只能输入正整数
export default {
  name: 'enterNum',
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function(el, binding) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
        if(e.preventDefault){
          e.preventDefault();
        }else{
          e.returnValue = false;
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/directives/enterNum.js